'use strict';

var novicell = novicell || {};


novicell.countersSection = novicell.countersSection || new function () {
    var counters = document.querySelectorAll(".counters-section-counters__block");

    this.init = function (){

        if(!counters) { return null };

        for (var i = 0; i < counters.length; i++) {
            var counter = counters[i];

            var endVal = counter.dataset.target ? parseFloat(counter.dataset.target) : null;

            if (endVal !== null) {

                var target = counter.querySelector(".counters-section-counters__block--data-holder");

                if (target !== null)
                {
                    var decimals = counter.dataset.decimals ? counter.dataset.decimals : 2;
                    var duration = counter.dataset.duration ? counter.dataset.duration : 2;

                    var customSettings = {
                        useEasing: true,
                        useGrouping: true,
                        separator: '.',
                        decimal: ',',
                        suffix: counter.dataset.suffix ? counter.dataset.suffix : '',
                        prefix: counter.dataset.prefix ? counter.dataset.prefix : '',
                    }

                    var x = new CountUp(target, 0, endVal, decimals, duration, customSettings);
                    x.start();
                }
            }
        }
    }
}();

